import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingOrderUpdateEventImplEncoder } from "../../encoder/FixingOrderUpdateEventImplEncoder";

import * as CubiqTS from "../../index";
import { FixingOrderUpdateEvent } from "../FixingOrderUpdateEvent";

export class FixingOrderUpdateEventImpl
  extends ConcreteEncodable
  implements FixingOrderUpdateEvent
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.FixingOrderUpdateEventImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public orderState: CubiqTS.OrderState;
  /*FID=3*/
  public orderTxTime: CubiqTS.moment.Moment | null = null;
  /*FID=4*/
  public externalClientReference: string;
  /*FID=5*/
  public orderData: CubiqTS.OrderData | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingOrderUpdateEventImplEncoder.Instance;
    this.setEncodableType(FixingOrderUpdateEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingOrderUpdateEventImpl[" +
      "orderId=" +
      this.orderId +
      "orderState=" +
      this.orderState +
      "orderTxTime=" +
      this.orderTxTime +
      "externalClientReference=" +
      this.externalClientReference +
      "orderData=" +
      this.orderData +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
